import LZString from 'lz-string';

/**
 * Compress a design snapshot string using LZ-String UTF-16 encoding.
 * Returns { compressedSnapshot, compressed, originalSizeBytes, compressedSizeBytes, compressionRatio }.
 */
export function compressSnapshot(raw) {
    const originalSizeBytes = new TextEncoder().encode(raw).length;
    const compressedSnapshot = LZString.compressToUTF16(raw);
    const compressedSizeBytes = compressedSnapshot.length * 2; // UTF-16 = 2 bytes per char
    const compressionRatio = originalSizeBytes > 0
        ? Math.round((1 - compressedSizeBytes / originalSizeBytes) * 100)
        : 0;
    return { compressedSnapshot, compressed: true, originalSizeBytes, compressedSizeBytes, compressionRatio };
}

/**
 * Decompress a bookmark's compressedSnapshot back to the original design string.
 */
export function decompressSnapshot(compressedSnapshot) {
    return LZString.decompressFromUTF16(compressedSnapshot);
}

/**
 * Format bytes as a human-readable size string.
 */
export function formatBytes(bytes) {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
}
